module.exports = "img/flags/SE.84e7b45.png";